import { CSSProperties } from "react";
import { GridCellPixelValues } from "./GridCellPixelValuesTracker";

export function getGroupGridPixelStyles(values: GridCellPixelValues): CSSProperties {
	return {
		["--group-grid-column-width"]: `${values.columnWidth}px`,
		["--group-grid-row-height"]: `${values.rowHeight}px`,
		["--group-grid-column-gutter"]: `${values.columnGutter}px`,
		["--group-grid-row-gutter"]: `${values.rowGutter}px`,
	};
}

export function getTileGridPixelStyles(values: GridCellPixelValues): CSSProperties {
	return {
		["--tile-grid-column-width"]: `${values.columnWidth}px`,
		["--tile-grid-row-height"]: `${values.rowHeight}px`,
		["--tile-grid-column-gap"]: `${values.columnGutter}px`,
		["--tile-grid-row-gap"]: `${values.rowGutter}px`,
	};
}
